import { render, staticRenderFns } from "./LeftImage.vue?vue&type=template&id=23f5ea55"
import script from "./LeftImage.vue?vue&type=script&lang=js"
export * from "./LeftImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports